/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, variant: NonNullable<unknown> }} Report_Line_SeatInputs */



/**
* | output |
* | --- |
* | "{plan} seat ({variant})" |
*
* @param {Report_Line_SeatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_line_seat = /** @type {((inputs: Report_Line_SeatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Line_SeatInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.plan}-Platz (${i?.variant})`)
	return /** @type {LocalizedString} */ (`${i?.plan} seat (${i?.variant})`)
});